import React from 'react';

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-100">
      <main>{children}</main>
    </div>
  );
};

export default AuthLayout;